import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Dropdown, Avatar, Badge } from 'antd'
import { useMsal } from '@azure/msal-react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { getUsuarioPerfilByIdAction } from '@redux/usuario/actions'
import ModalStockMinimo from 'pages/articulos/stock/modalStockMinimo'
import styles from './style.module.scss'

const mapStateToProps = ({ user, usuarioReducer }) => ({
  user,
  usuarioPerfil: usuarioReducer.usuarioPerfil,
})

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadPerfilUsuarios: (userId) => {
      getUsuarioPerfilByIdAction(dispatch, userId)
    },
  }
}

const ProfileMenu = ({ user, onLoadPerfilUsuarios, usuarioPerfil }) => {
  // const [count, setCount] = useState(7)

  const { instance } = useMsal()
  const { accounts } = useMsal()

  const name = accounts?.[0]?.name
  const userId = accounts?.[0]?.localAccountId

  const [modalStockMinimoVisible, setModalStockMinimoVisible] = useState(false)

  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!userId) return
    onLoadPerfilUsuarios(userId)
  }, [onLoadPerfilUsuarios, userId])

  const departamentoUsuario =
    usuarioPerfil?.data?.departamentoNombre ??
    usuarioPerfil?.data?.departamento?.nombre ??
    usuarioPerfil?.data?.departamento ??
    '- '

  useEffect(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (location.pathname === '/ventas/list' && usuarioPerfil?.data?.mostrarStockArticulos) {
      const fechaStock = new Date(usuarioPerfil?.data?.fechaStock)
      fechaStock.setHours(0, 0, 0, 0)
      if (fechaStock <= today) {
        setModalStockMinimoVisible(true)
      }
    }
  }, [usuarioPerfil])

  const imagenUrl = usuarioPerfil && usuarioPerfil.data ? usuarioPerfil.data.imagenUrl : null

  const handleMenuProfileClick = (e) => {
    e.preventDefault()
    history.push('/usuariosAdmin/profile/list')
  }

  function handleLogout() {
    instance.logoutRedirect().catch((e) => {
      console.error(e)
    })
  }
  /*
  const logout = e => {
    e.preventDefault()
    dispatch({
      type: 'user/LOGOUT',
    })
    history.push('/auth/login')
  }
  */

  /*
  const addCount = () => {
    setCount(count + 1)
  }
*/

  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    }
  }

  const items = [
    getItem(
      <div>
        <strong>
          <FormattedMessage id="topBar.profileMenu.hello" />, {name || 'Anonymous'}
        </strong>
        <div>
          <strong className="mr-1">
            <FormattedMessage id="topBar.profileMenu.department" />:{' '}
          </strong>{' '}
          {departamentoUsuario}
        </div>
        <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.responsibleUser" />:{' '}
          </strong>
          {usuarioPerfil?.data?.usuarioPadreNombre || '- '}
        </div>
      </div>,
      '1',
    ),
    { type: 'divider' },
    getItem(
      <div>
        <strong>
          <FormattedMessage id="topBar.profileMenu.email" />:{' '}
        </strong>
        {usuarioPerfil?.data?.email || '- '}
        <br />
        <strong>
          <FormattedMessage id="topBar.profileMenu.phone" />:{' '}
        </strong>
        {user.phone || '— '}
      </div>,
      '2',
    ),
    { type: 'divider' },
    getItem(
      <div>
        <a
          href="#"
          onClick={(e) => {
            handleMenuProfileClick(e)
          }}
        >
          <i className="fe fe-user mr-2" />
          <FormattedMessage id="topBar.profileMenu.editProfile" />
        </a>
      </div>,
      '3',
    ),
    { type: 'divider' },
    getItem(
      <div>
        <a href="#" onClick={() => handleLogout()}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </div>,
      '4',
    ),
  ]
  // eslint-disable-next-line no-unused-vars
  const menuProps = {
    items,
    // onClick: handleMenuClick,
  }
  /*
   const handleMenuClick = e => {
    // message.info('Click on menu item.')
    console.log('click', e)
  }
*/

  /*
  return (
    <Dropdown overlay={menu} trigger={['click']} onOpenChange={addCount}>
      <div className={styles.dropdown}>
        <Badge count={count}>
          <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
        </Badge>
      </div>
    </Dropdown>
  )
  */
  return (
    <>
      <div className="row align-items-center">
        <div className="col">
          <h3 style={{ margin: 0 }}>{accounts[0].name}</h3>
        </div>
        <div className="col">
          <Dropdown menu={menuProps} trigger={['click']}>
            <div className={styles.dropdown}>
              <Badge>
                <Avatar
                  className={styles.avatar}
                  shape="square"
                  size="large"
                  src={imagenUrl || null}
                  icon={!imagenUrl ? <UserOutlined /> : null}
                />
              </Badge>
            </div>
          </Dropdown>
        </div>
      </div>
      <ModalStockMinimo
        visible={modalStockMinimoVisible}
        setVisible={setModalStockMinimoVisible}
        usuarioId={accounts[0].localAccountId}
        nombreUsuario={accounts[0].name}
        width={600}
      />
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu)
